import type { VisitQr } from '@gymboard/types'
import { apiClient } from './api'

/** Rotating gym-floor check-in code for this (room-less) screen. */
export const getVisitQr = () => apiClient.get<VisitQr>('/visits/screen-qr')
